module.exports = "{{#each form in view.forms}}\r\n  {{view view.formView controller=controller model=form numPages=view.numPages}}\r\n{{/each}}\r\n"